module.exports = __webpack_public_path__ + "assets/25779f5cdd36a7d21badb9907cbd93cb.png";